$(document).ready(function () {
  clearBlockedCustomerCart();

  // Handle the quantity change
  $(document).on("click", ".quantity_input_block .increase-qty", function () {
    console.log("clicked");
    let productCard = $(this).parents(".custom_product_data");
    let quantity = parseInt(
      $(productCard).find('input[name="quantity"]').val()
    );
    quantity += 1;
    $(productCard).find('input[name="quantity"]').val(quantity);
    updateTotalPrice(productCard);
  });

  $(document).on("click", ".quantity_input_block .decrease-qty", function () {
    let productCard = $(this).parents(".custom_product_data");
    let quantity = parseInt(
      $(productCard).find('input[name="quantity"]').val()
    );
    if (quantity > 1) {
      quantity -= 1;
    }
    $(productCard).find('input[name="quantity"]').val(quantity);
    updateTotalPrice(productCard);
  });

  $(document).on("submit", 'form[name="customAddToCart"]', function (e) {
    e.preventDefault();
    if (window.customerIsBlocked) {
      return;
    }
    const $form = $(this);
    const formData = $form.serializeArray();

    const productId = $form.data('product-id');
    if (productId) {
      const dropperAddonName = $form.data('dropper-addon-name');
      const selected = dropperAddonName
        ? document.querySelector('input[name="' + dropperAddonName + '"]:checked')
        : document.querySelector('input[name="dropper_addon_' + productId + '"]:checked');
      const dropperInput = $form.find('input[name="dropper_variant_id"]').val();
      if (selected && selected.value === 'yes' && dropperInput) {
        const qty = parseInt($form.find('input[name="quantity"]').val(), 10) || 1;
        const bundleGroup = 'bundle_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
        const id = parseInt($form.find('input[name="id"]').val(), 10);
        const productIdVal = parseInt($form.find('input[name="product-id"]').val(), 10);
        const items = [{
          id: id,
          quantity: qty,
          productId: productIdVal,
          properties: { _bundle_group: bundleGroup, 'Dropper included': 'Yes' }
        }];
        items.push({
          id: parseInt(dropperInput, 10),
          quantity: qty,
          properties: { _bundle_group: bundleGroup, _is_dropper: 'true' }
        });
        formData.length = 0;
        formData.push({ name: "items", value: JSON.stringify(items) });
      }
    }

    customAddToCartProduct(formData, $form);
  });
});

async function clearBlockedCustomerCart() {
  if (!window.customerIsBlocked || window.blockedCustomerCartCleared) return;
  window.blockedCustomerCartCleared = true;

  try {
    const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
    const cart = await cartResponse.json();

    if (!cart.items || cart.items.length === 0) return;

    await fetch(`${window.Shopify.routes.root}cart/clear.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });

    document.dispatchEvent(new CustomEvent("cart:updated"));
    document.dispatchEvent(new Event("cart_page:updated"));

    if (window.location.pathname === window.routes.cart_url) {
      window.location.reload();
    }
  } catch (error) {
    console.error("Error clearing blocked customer cart:", error);
  }
}

function customAddToCartProduct(formData, $form) {
  if (window.customerIsBlocked) {
    return;
  }
  let data;
  $form.find("button").attr("disabled", true);
  $form.find(".loading__spinner").removeClass("hidden");

  const hasItemsField = formData.some((field) => field.name === "items");
  if (hasItemsField) {
    const itemsField = formData.find((field) => field.name === "items");
    try {
      data = JSON.parse(itemsField.value);
    } catch (error) {
      console.error("Error parsing 'items' field:", error);
      $form.find("button").attr("disabled", false);
      $form.find(".loading__spinner").addClass("hidden");
      return;
    }
  } else {
    data = {};
    formData.forEach((field) => {
      data[field.name] = field.value;
    });
    data = [data];
  }

  const generatedFormData = {
    items: data,
    sections: ["cart-drawer", "cart-icon-bubble"],
    sections_url: window.location.pathname,
  };

  fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(generatedFormData),
  })
    .then((response) => {
      if (!response.ok) {
        console.log($form.siblings(".add-to-cart-error-message"));
        if ($form.find(".add-to-cart-error-message").length > 0) {
          $form.find(".add-to-cart-error-message").css("display", "flex");
        }
        if ($form.siblings(".add-to-cart-error-message").length > 0) {
          $form.siblings(".add-to-cart-error-message").css("display", "flex");
        }
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => {
      window.handleFreeGift();
      const cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer) {
        cartDrawer.renderContents(data);
        cartDrawer.open();
      }
    })
    .catch((error) => {
      console.error("Error adding to cart:", error);
    })
    .finally(() => {
      $form.find("button").attr("disabled", false);
      $form.find(".loading__spinner").addClass("hidden");
      if ($("cart-drawer").hasClass("is-empty")) {
        $("cart-drawer").removeClass("is-empty");
      }
    });
}

// Function to calculate and update the total quantity price
function updateTotalPrice(productCard) {
  $(".add-to-cart-error-message").hide();
  let quantity =
    parseInt($(productCard).find('input[name="quantity"]').val()) || 0;
  let productPrice = $(productCard)
    .find(".quantity_input_block")
    .data("product-price");
  if (!productPrice) {
    console.error("Product price not found in data attribute");
    return;
  }
  let totalQuantityPrice = (productPrice * quantity) / 100;
  $(productCard)
    .find(".total_quantity_price")
    .text("$" + totalQuantityPrice.toFixed(2));
}

// PDP Page Add To Cart Functionalities
$(document).ready(function () {
  // Handle size box selection
  $(document).on("click", ".size_box .box", function (e) {
    const $box = $(this);
    if ($box.hasClass("out-of-stock")) {
      return;
    }
    const $sizeBox = $box.closest(".size_box");
    const $selectedBoxes = $sizeBox.find(".box.selected");
    // Check if the click occurred inside the .quantity_input_block
    if ($(e.target).closest(".quantity_input_block").length > 0) {
      return; // Exit if clicked inside .quantity_input_block
    }
    if ($box.hasClass("selected") && $selectedBoxes.length === 1) {
      return;
    }
    $box.toggleClass("selected");

    // Toggle dropper addon visibility based on selected box
    var $dropperAddon = $(".dropper-addon:not(.dropper-addon--card)");
    if ($dropperAddon.length) {
      var $anySelectedWithDropper = $sizeBox.find(".box.selected[data-dropper-variant-id]");
      if ($anySelectedWithDropper.length) {
        $dropperAddon.show();
      } else {
        $dropperAddon.hide();
        // Clear any selected dropper radio when hiding
        $dropperAddon.find('input[type="radio"]').prop("checked", false);
        var errorMsg = $dropperAddon.find(".dropper-addon-error");
        if (errorMsg.length) errorMsg.hide();
      }
    }
  });

  // Handle Add to Cart form submission
  $(document).on("submit", 'form[name="customPDPAddToCart"]', function (event) {
    event.preventDefault();
    if (window.customerIsBlocked) {
      return;
    }
    const $form = $(this);

    // Find all selected boxes
    const $selectedBoxes = $(".box.selected");
    const items = [];
    const selectedDropperOption = document.querySelector('input[name="dropper_addon"]:checked');
    const shouldAddDropper = selectedDropperOption && selectedDropperOption.value === 'yes';

    if ($selectedBoxes.filter('[data-dropper-variant-id]').length && !selectedDropperOption) {
      const errorMsg = document.querySelector('.dropper-addon-error');
      if (errorMsg) errorMsg.style.display = 'block';
      return;
    }

    $selectedBoxes.each(function () {
      const $box = $(this);
      const $idInput = $box.find('input[name="id"]');
      const $quantityInput = $box.find(".quantity__input");
      const $productIdInput = $box.find('input[name="product-id"]');
      const dropperVariantId = parseInt($box.data("dropper-variant-id"), 10);

      if ($idInput.length) {
        const id = parseInt($idInput.val(), 10);
        const quantity = $quantityInput.length
          ? parseInt($quantityInput.val(), 10) || 1
          : 1;
        const productId = $productIdInput.length
          ? parseInt($productIdInput.val(), 10)
          : null;

        var parentItem = { id, quantity, productId };
        if (shouldAddDropper && dropperVariantId) {
          const bundleGroup = 'bundle_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
          parentItem.properties = { _bundle_group: bundleGroup, 'Dropper included': 'Yes' };
          items.push(parentItem);
          items.push({
            id: dropperVariantId,
            quantity: quantity,
            properties: { _bundle_group: bundleGroup, _is_dropper: 'true' }
          });
          return;
        }
        items.push(parentItem);
      }
    });

    // Append additional items from global (e.g., dropper add-on)
    if (Array.isArray(window.__additionalCartItems)) {
      window.__additionalCartItems.forEach(function (additionalItem) {
        if (!items.some(function (item) { return item.id === additionalItem.id; })) {
          items.push(additionalItem);
        }
      });
    }

    // Set the items array as a JSON string in the hidden input field
    const $itemsInput = $form.find('input[name="items"]');
    if ($itemsInput.length) {
      $itemsInput.val(JSON.stringify(items));
    } else {
      console.warn('Hidden input field for "items" not found.');
      return;
    }

    // Serialize form data
    const formData = $form.serializeArray();
    customAddToCartProduct(formData, $form);
  });
});

$(document).ready(function () {
  $(".professional-card .box .more").on("click", function () {
    $(this).closest(".box").addClass("active");
  });

  $(".professional-card .box .less").on("click", function () {
    $(this).closest(".box").removeClass("active");
  });
});

$(document).on("click", ".video-card .play-btn", function () {
  var videoUrl = $(this).data("video");

  // Prevent popup from opening if there is no video
  if (!videoUrl) {
    return;
  }

  var isYouTube =
    videoUrl.includes("youtube.com") || videoUrl.includes("youtu.be");

  if (isYouTube) {
    $("#mp4-video").hide();
    $("#youtube-frame")
      .attr("src", videoUrl + "?autoplay=1")
      .show();
  } else {
    $("#youtube-frame").hide();
    $("#mp4-source").attr("src", videoUrl);
    $("#mp4-video")[0].load();
    $("#mp4-video").show();
  }

  $("#video-popup").fadeIn();
});

$("#video-popup .close-btn, #video-popup .close-btn img, #video-popup").click(
  function (e) {
    if (e.target === this) {
      $("#video-popup").fadeOut();
      $("#youtube-frame").attr("src", ""); // Stop YouTube
      $("#mp4-video")[0].pause(); // Stop MP4
    }
  }
);

// $(document).ready(function () {
//   $(".video-card .play-btn").click(function () {
//     var videoUrl = $(this).data("video");
//     var isYouTube =
//       videoUrl.includes("youtube.com") || videoUrl.includes("youtu.be");

//     if (isYouTube) {
//       $("#mp4-video").hide();
//       $("#youtube-frame")
//         .attr("src", videoUrl + "?autoplay=1")
//         .show();
//     } else {
//       $("#youtube-frame").hide();
//       $("#mp4-source").attr("src", videoUrl);
//       $("#mp4-video")[0].load();
//       $("#mp4-video").show();
//     }

//     $("#video-popup").fadeIn();
//   });

//   $("#video-popup .close-btn, #video-popup").click(function (e) {
//     if (e.target === this) {
//       $("#video-popup").fadeOut();
//       $("#youtube-frame").attr("src", ""); // Stop YouTube
//       $("#mp4-video")[0].pause(); // Stop MP4
//     }
//   });
// });

// Js for listen Now Popup

$(document).ready(function () {
  $(".listen-btn").click(function (event) {
    event.preventDefault(); // Prevent default action

    $("#popup").fadeIn();
  });

  $(".close-btn, #popup").click(function () {
    $("#popup").fadeOut();
  });

  $(".popup-content").click(function (event) {
    event.stopPropagation(); // Prevent closing when clicking inside the popup
  });
});

// Js for listen Now Popup

$(document).ready(function () {
  $(".listen-btn").click(function (event) {
    event.preventDefault(); // Prevent default action

    $("#popup").fadeIn();
  });

  $(".close-btn, #popup").click(function () {
    $("#popup").fadeOut();
  });

  $(".popup-content").click(function (event) {
    event.stopPropagation(); // Prevent closing when clicking inside the popup
  });
});


$(document).on('click', '.button-close.button--tertiary', function () {
  // Remove class from the info button
  $('.quantity-popover__info-button').removeClass('quantity-popover__info-button--open')
    .attr('aria-expanded', 'false');

  // Add hidden attribute to the info popup
  $('.cart-items__info.global-settings-popup.quantity-popover__info').attr('hidden', true);
});

async function clearCartItems() {
  try {
    await fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      }
    });
  } catch (err) {
    console.error('Failed to clear cart:', err);
  }
}

async function removeNonEventCartItems() {
  try {
    const response = await fetch('/cart.js');
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

    const cart = await response.json();
    const items = cart.items || [];

    const removableItems = items.filter(item => {
      const type = (item.product_type || '').trim().toLowerCase();
      return type !== 'event' && type !== 'digital education';
    });

    if (removableItems.length === 0) {
      return false; // Nothing to remove
    }

    for (const item of removableItems) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: item.key,
          quantity: 0
        })
      });
    }

    return true;
  } catch (err) {
    console.error('Failed to remove non-event/digital education items:', err);
  }
}


async function cartHasItems() {
  try {
    const response = await fetch('/cart.js');
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

    const cart = await response.json();
    return cart.items && cart.items.length > 0;
  } catch (err) {
    console.error('Failed to check cart:', err);
    return false; // assume empty if error
  }
}


$(document).ready(function () {
  let wasLoggedIn = window.isCustomerLoggedIn;

  setInterval(async () => {
    // Assume window.isCustomerLoggedIn has changed elsewhere if user logs out
    if (!wasLoggedIn) {
      const hasItems = await cartHasItems();

      if (hasItems) {
        const removed = await removeNonEventCartItems();
        if (removed) {
          window.location.reload();
        }
      }

      wasLoggedIn = false; // Prevents repeated clearing
    }
  }, 2000);
});

document.addEventListener("DOMContentLoaded", function() {
  const qtyBlocks = document.querySelectorAll('.quantity_input_block');

  qtyBlocks.forEach(block => {
    const input = block.querySelector('.quantity__input');
    const plusBtn = block.querySelector('.increase-qty');
    const minusBtn = block.querySelector('.decrease-qty');
    
    // 1. Get Base Price
    const basePrice = parseFloat(block.getAttribute('data-product-price'));
    
    // 2. Get Price Breaks (Parse the JSON we added in Liquid)
    let priceBreaks = [];
    try {
      priceBreaks = JSON.parse(block.getAttribute('data-price-breaks'));
      // Sort breaks descending by quantity (Largest quantity first) to make logic easier
      priceBreaks.sort((a, b) => b.qty - a.qty);
    } catch (e) {
      console.warn('Error parsing price breaks', e);
    }

    const parentBox = block.closest('.second-box'); // Adjust selector if your layout is different
    if (!parentBox) return;
    const priceDisplay = parentBox.querySelector('.price');
    if (!priceDisplay) return;

    // Helper: Format Money
    const formatMoney = (cents) => {
      const currentText = priceDisplay.innerText;
      const currencySymbolMatch = currentText.match(/[^0-9.,\s]+/); 
      const symbol = currencySymbolMatch ? currencySymbolMatch[0] : '$'; 
      return symbol + (cents / 100).toFixed(2);
    };

    // 3. Calculation Logic with Volume Pricing
    const updatePrice = () => {
      const currentQty = parseInt(input.value) || 1;
      
      // Default to base price
      let unitPrice = basePrice;

      // Check if current quantity meets any price break
      // Since we sorted descending, the first match is the best price
      const applicableBreak = priceBreaks.find(pb => currentQty >= pb.qty);
      
      if (applicableBreak) {
        unitPrice = applicableBreak.price;
      }

      // Calculate Total
      const totalCents = unitPrice * currentQty;

      // Update DOM
      priceDisplay.innerText = formatMoney(totalCents);
    };

    // Event Listeners
    input.addEventListener('input', updatePrice);
    input.addEventListener('change', updatePrice);
    if(plusBtn) plusBtn.addEventListener('click', () => setTimeout(updatePrice, 50));
    if(minusBtn) minusBtn.addEventListener('click', () => setTimeout(updatePrice, 50));
    
    // Initialize on load
    updatePrice();
  });
});
